export default __webpack_public_path__ + "static/media/error.98453f22.png";